export default "__VITE_ASSET__C55Hkjoe__"